import React, { useState } from 'react';
import useLanguage from '../../hooks/useLanguage';
import useOutsidOfDOMClick from '../../hooks/useOutsidOfDOMClick'; 

export default function LanguageDropDown() {
    const [showLangItems, setShowLangItems] = useState(false);
    const langDropDownRef = useOutsidOfDOMClick(() => {
        setShowLangItems(false);
    }, []);
    const {
        selectedLangName,
        langList,
        selectLang
    } = useLanguage();

    function onLangButtonClick() {
        setShowLangItems(showLangItems => !showLangItems);
    }
    
    function onLangMenuClick(e) {
        selectLang(e);
        setShowLangItems(false);
    }

    return (
        <div ref={langDropDownRef} className={['dropdown language', showLangItems ? 'open' : ''].join(' ')} data-tag="tagDropdownLanguage">
			<div className="dropdown-toggle btn btn-outline" onClick={onLangButtonClick}>
				{selectedLangName}
			</div>
			<div className="dropdown-menu" data-tag="tagLanguageList" onClick={onLangMenuClick}>
                {langList.map(lang => (
                    <a
                        key={lang.id}
                        className="dropdown-item"
                        href="#"
                        title={lang.name}
                        data-id={lang.id}
                        onClick={event => event.preventDefault()}
                    >
                        {lang.name}
                    </a>
                ))}
            </div>
		</div>
    );
}